import React from 'react';
import '../../App.scss';
import { updateState } from "../StateHelper";
import BuyerApi from '../../api/BuyerApi';
import AuthorizedPage from "../../component/AuthorizedPage";
import BasicGrid from "../../component/BasicGrid";
import { Form, Button, Table, Modal, Badge } from "react-bootstrap";
import { PlusSquare } from "react-bootstrap-icons";
import { Role } from '../../domain/Role';
import QuickSearchBox from '../../component/QuickSearchBox';
import QuickFilterButton from '../../component/QuickFilterButton';
import UserAccessApi from '../../api/UserAccessApi';

const gridProps = [
  { label: "Kodu", attr: "code" },
  { label: "VKN", attr: "vkn" },
  { label: "Unvan", attr: "title" },
  { label: "Email", attr: "email" },
  { label: "Telefon", attr: "phone1" }
];

class BuyerManagement extends React.Component<any,any> {

  constructor(props: any) {
    super(props);
    this.state = {
      domainObj: new Array(),
      filteredDomainObj: new Array(),
      selectedDomainObj: new Object(),
      showDomainModal: false,
      syncing: false,
      usersByRole: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.loadDomainObj = this.loadDomainObj.bind(this);
    this.onModalOpen = this.onModalOpen.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
  }

  componentDidMount() {
    this.loadDomainObj();
    this.loadUsersByRole("SALES_ADMIN");
  }

  async loadDomainObj() {
    let response = await BuyerApi.listAll();
    if (response.success) {
      updateState(this, "domainObj", response.data);
      updateState(this, "filteredDomainObj", response.data);
    }
  }
  // Yeni fonksiyon
  async syncExternalBuyers() {
    updateState(this, "syncing", true);
    try {
      let response = await BuyerApi.syncExternalBuyers(); // frontend api çağrısı
      if(response.success) {
        await this.loadDomainObj(); // listeyi yenile
      } else {
        alert("Senkronizasyon başarısız");
      }
    } catch(err) {
      console.error(err);
      alert("Hata oluştu");
    } finally {
      updateState(this, "syncing", false);
    }
  }

  async loadUsersByRole(roleStr?: string) {
    let response = await UserAccessApi.listUsersByRole(roleStr);
    if (response.success) {
      updateState(this, "usersByRole", response.data);
    }
  }

  async onSubmit(e: any) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData); // salesRepresentativeId de burada var
    let response = await BuyerApi.createOrUpdate(formObject);
    if(response.success) {
      e.target.reset();
      updateState(this ,"showDomainModal", false);
      updateState(this, "selectedDomainObj", {});
      this.loadDomainObj();
    }
  }


  onModalOpen() {
    updateState(this, "showDomainModal", true);
  }

  onModalClose() {
    updateState(this, "showDomainModal", false);
    updateState(this, "selectedDomainObj", new Object());
    this.loadDomainObj();
  }

  onSearch(q: string) {
    if (q && q.length <= 2) {
      return;
    }
    let matches = new Array();
    this.state.users.forEach((user: any) => {
      let userRaw = Object.values(user).join();
      if (userRaw.includes(q)) {
        matches.push(user);
      }
    });

    updateState(this, "filteredDomainObj", matches);
    return;
  }

  combineWithCallbacks(prob: any) {
    let userGridCallbacks = [
      {
        label: "Hesap Özeti",
        attr: "navigateToFinance",
        callback: this.onColumnEvent,
      },
      {
        label: "Düzenle",
        attr: "edit",
        callback: this.onColumnEvent,
      },
    ];
    let prp = prob;
    prp = prp.concat(userGridCallbacks);
    return prp;
  }

  async onColumnEvent(
    self: any,
    componentRef: any,
    column: any,
    selected: any
  ) {
    if("edit" == column) {
      updateState(self, "selectedDomainObj", selected);
      updateState(self, "showDomainModal", true);
    }

    if("navigateToFinance" == column) {
      window.location.assign("/musteri-finans-yonetimi?buyerId="+selected.id);
    }

  }

  domainCreateOrUpdateModal = () => {
    const {
      id, title, code, name, surname, phone1, phone2,
      email, tckn, vkn, taxOffice, addressMain, addressSecondary, salesRepresentativeId
    } = this.state.selectedDomainObj || {};

    const submitButtonText = id ? "Müşteri Bilgilerini Güncelle" : "Müşteri Tanımla";

    return (
      <Modal
        autoFocus
        show={this.state.showDomainModal}
        onHide={this.onModalClose}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Müşteri Oluştur veya Güncelle</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="centered-80-percent margin-left-right-40">
            <Form onSubmit={this.onSubmit}>
              <Form.Control name="id" type="hidden" defaultValue={id || null} />

              <div className="row">
                <div className="col-md-6">{this.renderFormField("Unvan", "title", title)}</div>
                <div className="col-md-6">{this.renderFormField("Müşteri Kodu", "code", code)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">{this.renderFormField("Ad", "name", name)}</div>
                <div className="col-md-6">{this.renderFormField("Soyad", "surname", surname)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">{this.renderFormField("E-Mail", "email", email)}</div>
                <div className="col-md-6">{this.renderFormField("Telefon", "phone1", phone1)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">{this.renderFormField("Telefon (Alternatif)", "phone2", phone2)}</div>
                <div className="col-md-6">{this.renderFormField("TC Kimlik No", "tckn", tckn)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">{this.renderFormField("Vergi Kimlik No", "vkn", vkn)}</div>
                <div className="col-md-6">{this.renderFormField("Vergi Dairesi", "taxOffice", taxOffice)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">{this.renderFormField("Adres", "addressMain", addressMain, true)}</div>
                <div className="col-md-6">{this.renderFormField("Adres (Alternatif)", "addressSecondary", addressSecondary, true)}</div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-4" controlId="formUser">
                    <Form.Label>Müşteri Sorumlusu</Form.Label>
                    <Form.Control
                      as="select"
                      name="salesRepresentativeId"
                      value={this.state.selectedDomainObj.salesRepresentativeId || ""}
                      onChange={(e) => {
                        const updatedObj = {
                          ...this.state.selectedDomainObj,
                          salesRepresentativeId: e.target.value
                        };
                        updateState(this, "selectedDomainObj", updatedObj);
                      }}
                    >
                      <option value="">Seçiniz</option>
                      {this.state.usersByRole.map((user: any) => (
                        <option key={user.id} value={user.id}>{user.nameAndSurname}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </div>

              <Button style={{ float: "right" }} variant="secondary" type="submit">
                {submitButtonText}
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  // Yardımcı fonksiyon
  renderFormField = (label: string, name: string, value?: string, asTextarea = false) => (
    <Form.Group className="mb-4" controlId={`form-${name}`}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        name={name}
        type={asTextarea ? undefined : "text"}
        as={asTextarea ? "textarea" : undefined}
        rows={asTextarea ? 2 : undefined}
        placeholder={label}
        defaultValue={value || ""}
      />
    </Form.Group>
  );


  render() {
    return (
      <AuthorizedPage role={Role.ACCOUNTING_MANAGER}>
        {this.domainCreateOrUpdateModal()}

        <div className="centered-95-percent">

          {/* Başlık + Butonlar */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h3 className="mb-0">👥 Müşteri Yönetimi</h3>

            <div>
              <Button
                variant="info"
                className="me-2"
                disabled={this.state.syncing}
                onClick={() => this.syncExternalBuyers()}
              >
                {this.state.syncing
                  ? <span className="spinner-border spinner-border-sm" />
                  : "🔄 Senkronize Et"}
              </Button>

              <Button
                variant="success"
                onClick={() => this.onModalOpen()}
              >
                <PlusSquare size={18} /> Müşteri Ekle
              </Button>
            </div>
          </div>

          {/* Arama */}
          <div className="mb-2">
            <QuickSearchBox
              items={this.state.domainObj}
              onSearch={(filtered: any) =>
                updateState(this, "filteredDomainObj", filtered)
              }
            />
          </div>

          {/* Tablo */}
          <BasicGrid
            title="Müşteriler"
            componentRef="domainGrid"
            that={this}
            data={this.state.filteredDomainObj}
            columnProps={this.combineWithCallbacks(gridProps)}
          />

        </div>
      </AuthorizedPage>
    );
  }


}

export default BuyerManagement;
